import { render, staticRenderFns } from "./view-serials.vue?vue&type=template&id=14938654&"
import script from "./view-serials.vue?vue&type=script&lang=ts&"
export * from "./view-serials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports